export const TOGGLE_MENU = 'TOGGLE_MENU'

export const FETCH_BUY_REQUEST = 'FETCH_BUY_REQUEST'
export const FETCH_SELL_REQUEST = 'FETCH_SELL_REQUEST'
export const FETCH_ARRAY = 'FETCH_ARRAY'//wallet
export const FETCH_TRANSACTIONS = 'TRANSACTIONS'
export const FETCH_RATES = 'RATES'